import React from 'react';
import { ThemeProvider } from '@fairygodboss/ui';
import { BottomConvincer } from '../SingleContent/SharedComponents/BottomConvincer/BottomConvincer';
import { AdvicePageProvider } from './AdvicePageContext';
import { AboveTheFold } from './components/AboveTheFold';
import { FeautredContent } from './components/FeaturedContent';
import { ExploreTopics } from './components/ExploreTopics';
import { ResetStyle } from '../SingleContent/SharedComponents/ResetStyle';

export const AdviceLandingPage = ({ contents, topicSelected, page }) => {
    return (
        <AdvicePageProvider
            contents={contents}
            topicSelected={topicSelected}
            slideSelected={page}
        >
            <ResetStyle>
                <ThemeProvider>
                    <AboveTheFold />
                    <FeautredContent />
                    <ExploreTopics />
                    <BottomConvincer
                        loginTrigger="advice-hub-registration"
                        miscEventType="advice_b_button"
                        redirectUrl="/advice"
                        alwaysDisplayButton
                        leftAltTag="A Fairygodboss VIP helps provide career advice to women in our network"
                        rightAltTag="Women in our career community"
                    />
                </ThemeProvider>
            </ResetStyle>
        </AdvicePageProvider>
    );
};
